<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 16.09.2020
  -- Description : Formulaire de création d'un métier depuis la liste des métiers
  -- Fichier : CreateMetierFromList.vue
  -->

<template>
  <v-row>
    <v-form ref="formCreateMetier" v-model="validCreateMetier" lazy-validation>
      <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="mx-3" color="primary">
            Ajouter un métier
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Ajouter un métier</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="typeMetier.libelle"
              :rules="libelleRules"
              label="Nom"
              required
            ></v-text-field>
            <v-text-field
              v-model="typeMetier.oldNames"
              label="Autres noms"
              :rules="oldNamesRules"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Fermer
            </v-btn>
            <v-btn color="blue darken-1" text @click="submit()">
              Sauvegarder
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-row>
</template>

<script>
import store from '@/store/index.js'
import NProgress from 'nprogress'

export default {
  data: () => ({
    validCreateMetier: true,
    dialog: false,
    typeMetier: {
      typeMetierId: 0,
      code: null,
      libelle: null
    },
    oldNamesRules: [],
    libelleRules: [v => !!v || 'Le champ est obligatoire']
  }),

  methods: {
    // Si le formulaire est valide, création d'un métier à une entreprise
    submit() {
      if (this.$refs.formCreateMetier.validate()) {
        NProgress.start()
        store
          .dispatch('typeMetier/createTypeMetier', this.typeMetier)
          .then(() => {
            this.$refs.formCreateMetier.reset()
            this.dialog = false
          })
          .catch(() => {})

        NProgress.done()
      }
    }
  }
}
</script>
